// Test IDs for the auth feature (login, register, password reset, logout).
// Add new keys here as you wire up additional auth UI; see ./index.js for
// the recipe to add a new feature file.
//
// Directive:
//   - Keys are camelCase, values are kebab-case shaped as `<feature>-<element>`
//     (or `<feature>-<element>-<qualifier>` when an element repeats). Examples:
//     'login-submit-button', 'cart-quantity-input', 'product-card-image'.
//   - Reference them in JSX as `data-testid={LOGIN.submitButton}`.
//
// Why kebab-case values: required by the CSS-attribute selector matcher used
// by the end-to-end test runner.

export const LOGIN = {
	emailInput: 'login-email-input',
	passwordInput: 'login-password-input',
	submitButton: 'login-submit-button',
	forgotPasswordLink: 'login-forgot-password-link',
	registerLink: 'login-register-link',
};

// Sign-in by one-time code (login OTP): the mobile/email step, then the code step.
export const LOGIN_OTP = {
	requestForm: 'login-otp-request-form',
	identifierInput: 'login-otp-identifier-input',
	requestButton: 'login-otp-request-button',
	requestError: 'login-otp-request-error',
	form: 'login-otp-form',
	message: 'login-otp-message',
	codeInput: 'login-otp-code-input',
	verifyButton: 'login-otp-verify-button',
	resendButton: 'login-otp-resend-button',
	backLink: 'login-otp-back-link',
	notice: 'login-otp-notice',
	error: 'login-otp-error',
};

// Login OTP settings dialog on Access Control (super_admin / hq_admin only).
export const LOGIN_OTP_SETTINGS = {
	openButton: 'login-otp-settings-open-button',
	enabledSwitch: 'login-otp-settings-enabled-switch',
	whatsappSwitch: 'login-otp-settings-whatsapp-switch',
	emailSwitch: 'login-otp-settings-email-switch',
	workingHoursInput: 'login-otp-settings-working-hours-input',
	logoutAfterHoursSwitch: 'login-otp-settings-logout-after-hours-switch',
	templateInput: 'login-otp-settings-template-input',
	approvalTemplateInput: 'login-otp-settings-approval-template-input',
	languageInput: 'login-otp-settings-language-input',
	status: 'login-otp-settings-status',
	testButton: 'login-otp-settings-test-button',
	testResults: 'login-otp-settings-test-results',
	saveButton: 'login-otp-settings-save-button',
};

export const REGISTER = {
	nameInput: 'register-name-input',
	emailInput: 'register-email-input',
	passwordInput: 'register-password-input',
	passwordConfirmInput: 'register-password-confirm-input',
	submitButton: 'register-submit-button',
	loginLink: 'register-login-link',
};

export const LOGOUT = {
	button: 'logout-button',
};
